import {
  GET_SPECIALISTS,
  GET_SPECIALIST,
  SPECIALISTS_ERROR,
  SPECIALIST_ERROR,
} from './types';
import api from '../utils/api';

const getErrorPayload = (err, fallbackMsg) => ({
  msg:
    err?.response?.statusText ||
    err?.response?.data?.msg ||
    err?.response?.data?.error ||
    err?.message ||
    fallbackMsg,
  status: err?.response?.status || 500,
});

// Get all profiles
export const getSpecialists = () => async (dispatch) => {
  try {
    const res = await api.get('/specialists');

    dispatch({
      type: GET_SPECIALISTS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: SPECIALISTS_ERROR,
      payload: getErrorPayload(err, 'Error obteniendo especialistas'),
    });
  }
};

// Get specialist by ID
export const getSpecialistByID = (id) => async (dispatch) => {
  try {
    const res = await api.get(`./specialists/${id}`);
    dispatch({
      type: GET_SPECIALIST,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: SPECIALIST_ERROR,
      payload: getErrorPayload(err, 'Error obteniendo terapeuta'),
    });
  }
};

// Get specialist by Nombres
export const getSpecialistByNombres = (nombres) => async (dispatch) => {
  try {
    const res = await api.get(
      `./specialists/getByNombres/${encodeURIComponent(nombres)}`
    );
    dispatch({
      type: GET_SPECIALIST,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: SPECIALIST_ERROR,
      payload: getErrorPayload(err, 'Error obteniendo terapeuta'),
    });
  }
};
